import React from 'react';

import {BufferConditionKeys, MeltingTempPreferences, NucleotideType} from 'biojs/BioConstants';

import MeltingTempOption from './MeltingTempOption';

interface Primer3MeltingTempParamsProps {
  optionsHaveValidationError: {[key in BufferConditionKeys]: boolean};
  meltingTempOptions: MeltingTempPreferences;
  setMeltingTempOptions: (prefs: MeltingTempPreferences) => void;
  setOptionsHaveValidationError: (errors: {[key in BufferConditionKeys]: boolean}) => void;
}

export default function Primer3MeltingTempParams(props: Primer3MeltingTempParamsProps): JSX.Element {
  return (
    <div className="row param-primer3">
      <MeltingTempOption nucleotideType={NucleotideType.RNA} optionKey="divalentConc" {...props} />
      <MeltingTempOption nucleotideType={NucleotideType.RNA} optionKey="dntpConc" {...props} />
    </div>
  );
}
